module.exports = __webpack_public_path__ + "static/img/11.db9f7aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/sp/11.png
// module id = II2r
// module chunks = 0